<script lang="ts" setup generic="TColumn extends {}">
import { computed } from 'vue'
import GwBox from '@/components/lib/GwBox/GwBox.vue'
import type { GwTableSortConf, GwTableColumn, GwTableVariantHeadTh } from './gwTableUtils'
import GwUiType from '@/components/lib/GwTable/GwUiType.vue'

export interface GwTableThProps<ColumnType> {
  item: GwTableColumn<ColumnType>
  sortConf?: GwTableSortConf<GwTableColumn<ColumnType>['sortKey']>
  variant: GwTableVariantHeadTh
  active?: boolean
}

type GwTableThEmits = {
  'th:click': [Event, GwTableColumn<TColumn>]
  'th:mousedown': [Event, GwTableColumn<TColumn>]
  'th:mouseup': [Event, GwTableColumn<TColumn>]
  'th:touchstart': [Event, GwTableColumn<TColumn>]
  'th:touchend': [Event, GwTableColumn<TColumn>]
}

const props = defineProps<GwTableThProps<TColumn>>()

const emit = defineEmits<GwTableThEmits>()

const active = computed(
  () => !!(props.sortConf?.sortKey && props.sortConf?.sortKey === props.item.sortKey),
)

const handleClick = (event: MouseEvent) => {
  emit('th:click', event, props.item)
}
</script>

<template>
  <th
    :id="`th_${item.id}`"
    :class="item.isDragging && 'clr-back-black-2'"
  >
    <div
      :class="item.subColumns && 'd-flex'"
      :style="item.subColumns && 'padding-right: 28px'"
    >
      <GwBox
        v-for="it in item.subColumns || [item]"
        :key="it.id"
        :variant
        class="gw_hvr flex-1"
        style="min-height: var(--app-height-table)"
        :style="`min-width: ${it.width || 'auto'}`"
        :active
        :disabled="!it.sortKey"
        @click="handleClick($event)"
        @mousedown="emit('th:mousedown', $event, it)"
        @mouseup="emit('th:mouseup', $event, it)"
        @touchstart="emit('th:touchstart', $event, it)"
        @touchend="emit('th:touchend', $event, it)"
      >
        <slot
          name="thcell_before"
          :item="it"
        >
        </slot>
        <slot>
          <div
            style="padding: 0 var(--th-pad-right) 0 var(--th-pad-left)"
            class="text-left"
            v-html="it.name"
          ></div>
        </slot>
        <div
          v-if="it.sortKey"
          class="gwtable_th_sortbtn mdi clr-primary text-semi-large px-2"
          :class="[
            { gw_hvr_content: !active },
            sortConf?.sortOrder === 'ASC' ? 'mdi-arrow-down-thin' : 'mdi-arrow-up-thin',
          ]"
        />
      </GwBox>
    </div>
  </th>
</template>
